module.exports = __webpack_public_path__ + "static/img/tubiao_chengse_2.9457249.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dashboard/tubiao_chengse_2.png
// module id = 0Fd2
// module chunks = 2